import {
  CustomerBankAccountMandateStateEnumType,
  Maybe,
  B2BPaymentMethod,
  PaymentMethodState,
} from "@oysterhr/schema"
import { Alert, Text } from "@oysterhr/ui"
import { Trans, useTranslation } from "react-i18next"
import { PaymentMethodEnumType } from "~/app/utils/constants"

interface SignRequestSentAlertProps {
  paymentMethod?: Maybe<B2BPaymentMethod>
  onResend: () => void
}

export const SignRequestSentAlert = ({ paymentMethod, onResend }: SignRequestSentAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")

  if (
    paymentMethod?.__typename !== PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA ||
    !paymentMethod.userNotSigner ||
    paymentMethod.state !== PaymentMethodState.AuthorizedByUser ||
    paymentMethod.mandate?.state !== CustomerBankAccountMandateStateEnumType.Initialized
  )
    return null

  return (
    <Alert variation="warning">
      <Alert.Icon />
      <Alert.Content className="flex space-x-1">
        <div className="flex">
          <Text className="mr-2">
            <Trans
              defaults={t("alerts.signRequestSent.content", { email: paymentMethod.email })}
              components={{ strong: <strong /> }}
            />
          </Text>
          <button type="button" className="font-normal underline" onClick={onResend}>
            {t("alerts.signRequestSent.action")}
          </button>
        </div>
      </Alert.Content>
    </Alert>
  )
}
